import api from '../../../api';
import moment from 'moment';
import config from 'config';
import {getTranslate} from "react-localize-redux/lib/index";

const GET_LIST= 'GET_LIST';
const UPDATE_KEY= 'UPDATE_KEY';
const PATIENT_ONCHANGE= 'PATIENT_ONCHANGE';
const PAGINATE = 'PAGINATE'
const checkTest = ['Colposcopy', 'Biopsy'];
const limit = 10;
let dateformat = config.language.dateTimeFormat;
var popupCervixData = [];
const sortAsc = 'sortField';
const sortDec = '-sortField'
export function getList() {
	return (dispatch, getState) => {
    let locale = {...getState().locale};
    dateformat = config.languages[locale.options.defaultLanguage].dateTimeFormat;
		return new Promise((resolve, reject) => {
			let status = {...getState().status};
			let body = {
				limit,
				skip: 0,
				sort: status.sortAsc ? sortAsc : sortDec
			}
			api.post('/exams/patients/', body).then(response => {
				status.lockPaginate = false;
				if (response.exams.length == 0) {
					status.lockPaginate = true;
				}
				status.listExam = formatExams(response.exams)
				dispatch({
					type: GET_LIST,
					payload: status
				})
				resolve();
			})
		})
	}
}

export function updateKey(key, value) {
	return (dispatch, getState) => {
		return new Promise((resolve, reject) => {
			let status = {...getState().status};
            let locale = {...getState().locale};
            let translate = getTranslate(locale);

			if (key !== 'popupSaved' || (key =='popupSaved' && !value)) {
				status[key] = value;
				dispatch({
					type: UPDATE_KEY,
					payload: status
				})
				resolve();
			}
			switch(key) {
				case 'popupSaved': {
					if (value) {
							status[key] = value;
							let listChange= status.listExam
							.filter(k=> k.changes.length)
							.map(k => {
								let data= {
									'_id': k._id,
									'patient': k.patient[0]._id
								}
								k.changes.map(key => {
									data[key] = k[key]
								})
								return data
							})
							let length = listChange.length;
							let content;
						  if (length > 1) {
						    content = length + ' ' + translate('update_review_plural');
						  } else if (length == 1) {
						    content = length + ' ' + translate('update_review');
						  } else {
						    content = translate('no_update_review');
						  }
						  if (listChange.length) {
								api.put('/exams/patients', listChange).then(response => {
					  			let body = {
										limit,
										skip: 0,
										sort: status.sortAsc ? sortAsc : sortDec
									}
									api.post('/exams/patients/', body).then(response => {
										status.listExam = formatExams(response.exams)
										let length = status.listExam.length
										 if (length > 1) {
									    content += length + ' ' + translate('need_review_plural');
									  } else if (length  == 1) {
									    content += length + ' ' + translate('need_review');
									  }  else {
									  	content += translate('no_need_review');
									  }
										status.popupSavedContent = content;
										dispatch({
											type: GET_LIST,
											payload: status
										})
										resolve();
									})
								})
						  } else {
								let length = status.listExam.length
							  if (length > 1) {
							    content += length + ' ' + translate('need_review_plural');
							  } else if (length  == 1) {
							    content += length + ' ' + translate('need_review');
							  }  else {
							  	content += translate('no_need_review');
							  }
								status.popupSavedContent = content;
								dispatch({
									type: GET_LIST,
									payload: status
								})
								resolve();
						  }

					} else {
						resolve();
					}
					break;
				}
				case 'sortAsc': {
					dispatch(getList());
					break;
				}
				default: {
					resolve();
					break;
				}
			}
		})
	}
}
const formatExams = (listExam) => {
	listExam.map(k => {
		k.patient[0].profile.dobFormatted =dateFormat(k.patient[0].profile.dob);
		if (k.date) {
			k.date = new Date(k.date);
		}
		if(!k.data) {
			k.data = {};
			k.data.IMP = [];
			for(var i = 0; i < 20; i++) {
				k.data.IMP.push({ID: ['0','0','0']})
			}
		}
		let arr = []
		k.data.IMP.map(k => {
			let sum = 0;
			k.ID.map(k => {
				sum += (k-0);
			});
			arr.push(sum);
		})
		k.popupCervixData = arr;
		if (k.results_date) {
			k.results_date = new Date(k.results_date)
		}
		if (k.status == null) {
			k.status = undefined;
		}

		if (k.status > 1 && checkTest.includes(k.test_type)) {
			k.colonoscopyIcon = true
		}
		k.changes = []
	})
	return listExam
}
export function patientOnChange(key, value, patientIndex, testIndex) {
	return (dispatch, getState) => {
		return new Promise((resolve, reject) => {
			let status = {...getState().status};
			switch(key) {
				case 'status':
				case 'test_type': {
					status.listExam[patientIndex][key] = value;
					if (status.listExam[patientIndex].status > 1 && checkTest.includes(status.listExam[patientIndex].test_type)) {
						status.listExam[patientIndex].colonoscopyIcon = true;
						status.popupCervix = true;
						status.popupCervixIndex = patientIndex;
						status.popupCervixData = status.listExam[patientIndex].popupCervixData
					} else {
						status.listExam[patientIndex].colonoscopyIcon = false;
					}
					break;
				}
				case 'files': {
					status.listExam[patientIndex][key] = [value];
					break;
				}
				case 'notes': {
					status.listExam[patientIndex][key].report = value;
					break;
				}
				case 'data': {
					// status.listExam[patientIndex].data.IMP.map(k => {
					// 	k.ID = ['0','0','0'];
					// })
					status.listExam[patientIndex].data.IMP[testIndex].ID = value;
					let arr = []
					status.listExam[patientIndex].data.IMP.map(k => {
							let sum = 0;
							k.ID.map(k => {
								sum += (k-0);
							});
							arr.push(sum);
					})
					status.listExam[patientIndex].popupCervixData = arr;
					break;
				}
				case 'popupCervixData': {
					status.listExam[patientIndex].popupCervixData = value;
					status.listExam[patientIndex].data.IMP.map(k => {
						k.ID = ['0','0','0'];
					})
					value.map((k, index) =>{
						if (k==0) {
							status.listExam[patientIndex].data.IMP[index].ID = [0, 0, 0];
						} else {
							status.listExam[patientIndex].data.IMP[index].ID = [1, 1, 1];
						}
					})
				}
				default:{
					status.listExam[patientIndex][key] = value;
					break;
				}
			}
			status.listExam[patientIndex].changes.push(key);
			dispatch({
				type: PATIENT_ONCHANGE,
				payload: status
			})
			resolve()
		})
	}
}

export const paginate = () => {
	return (dispatch, getState) => {
		return new Promise((resolve, reject) => {
			let status = {...getState().status};
			let body = {
				limit,
				skip: status.listExam.length,
				sort: status.sortAsc ? sortAsc : sortDec
			}
			status.lockPaginate = true;
			status.isLoading = true;
			dispatch({
				type: PAGINATE,
				payload: status
			});
			api.post('/exams/patients/', body, true)
			.then(list => {
				let status = {...getState().status};
				status.isLoading = false;
				status.listExam = [...status.listExam,...formatExams(list.exams)];
				status.lockPaginate = (list.exams.length < limit) ? true : false;
				dispatch({
					type: PAGINATE,
					payload: status
				});
				resolve()
			})
		});
	}
}

export function dateFormat(date) {
	return moment(date).format(dateformat);
}

const ACTION_HANDLERS = {
	[GET_LIST]: (state, action) => action.payload,
	[UPDATE_KEY]: (state, action) => action.payload,
	[PATIENT_ONCHANGE]: (state, action) => action.payload,
	[PAGINATE]: (state, action) => action.payload,
}


const initialState =  {
	listExam: [],
	cellSelected: 0,
	popupSaved: false,
	popupCervix: false,
	notePopup: false,
	changesList: {},
	notesContent: '',
	lockPaginate: false,
	isLoading: false,
	popupSavedContent: '',
	popupCervixData : [],
	sortAsc: true
}
export default function counterReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/routes/Status/modules/status.js